import { useThemeObserver } from '@atlaskit/tokens';
import { useMemo } from 'react';
import { DARK_ORDINAL_COLORS, LIGHT_ORDINAL_COLORS } from '..';
export const useChartColors = () => {
  const {
    colorMode
  } = useThemeObserver();
  const colors = useMemo(() => colorMode === 'dark' ? DARK_ORDINAL_COLORS : LIGHT_ORDINAL_COLORS, [colorMode]);
  return colors;
};